import moment from "moment";

export const ConvertView = (view=238435768) => {
  let len = view?.length;
  if (len >= 7) return `${(parseInt(view) / 1000000).toFixed(1)}M views`;
  if (len > 3 || len < 6)
    return `${(parseInt(view) / 10000).toFixed(1)}K views`;
  else return `${view} views`;
};

export const ConvertDate = (date) => {
  var dateofvisit = moment(date, "DD-MM-YYYY");
  var today = moment();
  var diff = today.diff(dateofvisit, "days");
  if (diff > 0) {
    return diff > 365 ? `1 years ago` : `${diff} days ago`;
  } else {
    // let y=moment(date).fromNow() return in a days ago format
    var now = moment(); //todays date
    var end = moment(date); // another date
    var duration = moment.duration(now.diff(end));
    var days = duration.asDays();
    var floorDay = Math.floor(days);
    return floorDay < 30
      ? `${floorDay} days ago`
      : `${Math.floor(floorDay / 30)} months ago`;
  }
};



export const simpleDateInYTDForm =(date) => {
  var d= moment(date).format("LL");
  return d.toString();
}
